import { useMemo } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../i18n/messages';
import { TestCycleTypesFromConfig } from '@oneaudi/vtp-configuration-service';
const useNedcLabels = () => {
    const nedcLabels = messages.testCycleLabels.nedc;
    const urbanLabel = useI18n(nedcLabels.urban);
    const extraUrbanLabel = useI18n(nedcLabels.extraUrban);
    const nedcCombinedLabel = useI18n(nedcLabels.combined);
    const plugInCombinedLabel = useI18n(nedcLabels.plugInCombined);
    return useMemo(() => [
        { key: 'urban', label: urbanLabel },
        { key: 'extraUrban', label: extraUrbanLabel },
        { key: 'combined', label: nedcCombinedLabel },
        { key: 'plugInCombined', label: plugInCombinedLabel },
    ], [nedcCombinedLabel, extraUrbanLabel, plugInCombinedLabel, urbanLabel]);
};
const useWltpLabels = () => {
    const wltpLabels = messages.testCycleLabels.wltp;
    const lowLabel = useI18n(wltpLabels.low);
    const mediumLabel = useI18n(wltpLabels.medium);
    const highLabel = useI18n(wltpLabels.high);
    const extraHighLabel = useI18n(wltpLabels.extraHigh);
    const wltpCombinedLabel = useI18n(wltpLabels.combined);
    const wltpPlugInCombinedLabel = useI18n(wltpLabels.plugInCombined);
    return useMemo(() => [
        { key: 'low', label: lowLabel },
        { key: 'medium', label: mediumLabel },
        { key: 'high', label: highLabel },
        { key: 'extraHigh', label: extraHighLabel },
        { key: 'combined', label: wltpCombinedLabel },
        { key: 'plugInCombined', label: wltpPlugInCombinedLabel },
    ], [extraHighLabel, highLabel, lowLabel, mediumLabel, wltpCombinedLabel, wltpPlugInCombinedLabel]);
};
export const useConsumptionTestCycleEntriesLookup = () => {
    const wltpLabelsArray = useWltpLabels();
    const nedcLabelsArray = useNedcLabels();
    const map = useMemo(() => new Map([
        [
            TestCycleTypesFromConfig.WLTP,
            wltpLabelsArray,
        ],
        [
            TestCycleTypesFromConfig.NEDC,
            nedcLabelsArray,
        ],
    ]), [nedcLabelsArray, wltpLabelsArray]);
    return useMemo(() => map, [map]);
};
